import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import VerticalNavLink from '../verticalNavLink';

function MAListJobsMediaMover({ onActive, handleDrawerToggle }) {
    return (
        <List disablePadding>
            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/jobs/media-mover/overview'}
                onClick={handleDrawerToggle}
                secondary={'Media Mover Overview'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/jobs/media-mover/jobs'}
                onClick={handleDrawerToggle}
                secondary={'Media Mover Jobs'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/jobs/media-mover/advanced-configuration'}
                onClick={handleDrawerToggle}
                secondary={'Advanced Configuration'}
            />
        </List>
    );
}

MAListJobsMediaMover.propTypes = {
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default MAListJobsMediaMover;
